import { DAYS_OF_WEEK } from '@/lib/constants';

/**
 * Converts a bitmask to day of the week array
 * @param bitmask - ex 81
 * @returns [mon, fri, sun]
 */
export const bitmaskToDays = (bitmask: number): string[] => {
  return DAYS_OF_WEEK.reduce((dayArray: string[], _, i) => {
    // Check if the bit at position i is set (1)
    // eslint-disable-next-line no-bitwise
    if ((bitmask & (1 << i)) !== 0) {
      dayArray.push(DAYS_OF_WEEK[i]);
    }
    return dayArray;
  }, []);
};
